import { twMerge } from "tailwind-merge";

export default function Label({ children, className = "", ...rest }) {
  return (
    <>
      <label
        {...rest}
        className={twMerge(`text-theme-blue font-bold text-2xl`, className)}
      >
        {children}
      </label>
    </>
  );
}
